import { createContext, useContext, useState, useEffect } from 'react';

const SocialLinksContext = createContext();

export const SocialLinksProvider = ({ children }) => {
  const [socialLinks, setSocialLinks] = useState({
    github: {
      links: ["https://github.com/dhirajth"],
      visible: true
    },
    linkedin: {
      links: ["https://linkedin.com/in/dhirajth"],
      visible: true
    },
    twitter: {
      links: ["https://twitter.com/dhirajth"],
      visible: false
    },
    instagram: {
      links: ["https://instagram.com/dhirajth"],
      visible: false
    },
    youtube: {
      links: ["https://youtube.com/@dhirajth"],
      visible: false
    },
    facebook: {
      links: ["https://facebook.com/dhirajth"],
      visible: false
    }
  });

  useEffect(() => {
    // Load social links from localStorage on mount
    try {
      const savedLinks = localStorage.getItem('socialLinks');
      if (savedLinks) {
        const parsedLinks = JSON.parse(savedLinks);
        // Validate the structure of saved links
        const isValid = Object.keys(parsedLinks).every(key => 
          parsedLinks[key] && 
          Array.isArray(parsedLinks[key].links) && 
          parsedLinks[key].links.every(link => typeof link === 'string') &&
          typeof parsedLinks[key].visible === 'boolean'
        );
        
        if (isValid) {
          setSocialLinks(parsedLinks);
        } else {
          console.warn('Invalid social links structure in localStorage, using defaults');
        }
      }
    } catch (error) {
      console.error('Error loading social links:', error);
    }
  }, []);

  const updateSocialLinks = (newLinks) => {
    try {
      // Validate the structure of new links
      const isValid = Object.keys(newLinks).every(key => 
        newLinks[key] && 
        Array.isArray(newLinks[key].links) && 
        newLinks[key].links.every(link => typeof link === 'string') &&
        typeof newLinks[key].visible === 'boolean'
      );
      
      if (isValid) {
        setSocialLinks(newLinks);
        localStorage.setItem('socialLinks', JSON.stringify(newLinks));
      } else {
        console.error('Invalid social links structure');
      }
    } catch (error) {
      console.error('Error updating social links:', error);
    }
  };

  return (
    <SocialLinksContext.Provider value={{ socialLinks, updateSocialLinks }}>
      {children}
    </SocialLinksContext.Provider>
  );
};

export const useSocialLinks = () => {
  const context = useContext(SocialLinksContext);
  if (!context) {
    throw new Error('useSocialLinks must be used within a SocialLinksProvider');
  }
  return context;
}; 